function showDevBlockedCartNotice(onContinue) {
    if (document.querySelector('.wccp-dev-cart-blocked')) return;

    const wrap = document.createElement('div');
    wrap.className = 'wccp-dev-cart-blocked';
    wrap.style.cssText = `
        margin: 16px 0;
        padding: 12px 14px;
        border: 2px dashed #c00;
        background: #fff5f5;
        color: #900;
        font-size: 14px;
    `;

    wrap.innerHTML = `
        <div style="font-weight:bold;margin-bottom:6px">
            DEV MODE: Auto redirect to cart is disabled
        </div>
        <div style="margin-bottom:10px">
            The constructor is working normally, but automatic redirect to cart
            was blocked for debugging purposes.
        </div>
        <button type="button"
            style="background-color: #ff8114; border-color: #ff8114; color: #fff; font-size: 14px; cursor: pointer;"
            class="button button-primary wccp-dev-continue-cart button-dev-continue-cart">
            Continue to cart
        </button>
    `;

    const btn = wrap.querySelector('.wccp-dev-continue-cart');
    btn.addEventListener('click', () => {
        wrap.remove();
        if (typeof onContinue === 'function') {
            onContinue();
        }
    });

    const root =
        document.getElementById('wccp-composite-root') ||
        document.querySelector('.wccp-composite-root');

    if (root) {
        root.appendChild(wrap);
    } else {
        document.body.appendChild(wrap);
    }
}


async function addCompositeToCart() {
    const payload = buildAddToCartPayload();
    // ===== DEV: CART OBJECT DATA =====
    var dev = window.WCCP_DEV_MODE;
    var enabled = !!(dev && dev.debug && dev.debug.cartObject);

    if (enabled) {
        devLog('[DEV] CART_OBJECT_DATA:', payload);
    }
    // ===== END DEV =====

    if (!payload.product_id || !Object.keys(payload.components).length) {
        alert('Please complete all required selections before adding to cart.');
        return; 
    }

    // ===== DEV: BLOCK VIA DEBUGGER =====
    var blockDebugger = !!(
        dev &&
        dev.redirectDebugger === true
    );

    if (blockDebugger) {
        devLog(
            'REDIRECT_DEBUGGER',
            'Execution paused before add-to-cart AJAX'
        );

        devLog('REDIRECT_DEBUGGER', {
            message: 'Open DevTools to activate debugger breakpoint',
            hint: 'Press F12 or Cmd+Option+I'
        });

        // execution stop
        debugger;
    }

    // ===== END DEV =====


    const body = new URLSearchParams();
    body.set('action', 'wccp_add_to_cart');
    body.set('product_id', String(payload.product_id));
    body.set('qty', String(payload.qty || 1));
    // body.set('min_qty', String(payload.min_qty));


    const nonce = (window.cdi_door_filter_ajax && window.cdi_door_filter_ajax.nonce) || '';
    if (nonce) body.set('door_filter_nonce', nonce);

    Object.entries(payload.components).forEach(([cid, row]) => {
        body.set(`components[${cid}][product_id]`, String(row.product_id));
        if (row.variation_id) {
            body.set(`components[${cid}][variation_id]`, String(row.variation_id));
        }
        if (row.qty) {
            body.set(`components[${cid}][qty]`, String(row.qty));
        }
        if (row.attributes) {
            Object.entries(row.attributes).forEach(([k, v]) => {
                body.set(`components[${cid}][attributes][${k}]`, String(v));
            });
        }
    });

    if (payload.accessories && payload.accessories.length > 0) {
        payload.accessories.forEach((acc) => {
            const pid = String(acc.product_id);
            body.set(`accessories[${pid}][product_id]`, pid);
            body.set(`accessories[${pid}][qty]`, String(acc.qty));
        });
    }

    // DEV: disable redirect
    if (window.WCCP_DEV_MODE?.blockAutoRedirectCart){
        window.WCCP_DEV_CONSOLE?.warn(
            "REDIRECT_BLOCKED",
            "addCompositeToCart skipped"
        );

        showDevBlockedCartNotice(async () => {
            // temporarily bypass DEV flag
            const prev = window.WCCP_DEV_MODE.blockAutoRedirectCart;
            window.WCCP_DEV_MODE.blockAutoRedirectCart = false;
            try {
                await addCompositeToCart();
            } finally {
                window.WCCP_DEV_MODE.blockAutoRedirectCart = prev;
            }
        });

        return false;
    }


    // Not retried (a retry could add the kit twice); a network or server error used to leave the builder hanging.
    let json;
    try {
        const res = await fetch((window.cdi_door_filter_ajax && window.cdi_door_filter_ajax.ajax_url) || '/wp-admin/admin-ajax.php', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: body.toString()
        });
        json = await res.json();
    } catch (e) {
        alert("We couldn't reach the server to add this kit to your cart. Please check your connection and try again.");
        return;
    }

    if (!json?.success) {
        const msg = (json && json.data && json.data.message) ? json.data.message : 'Failed to add to cart.';
        alert(msg);
        return;
    }

    if (json.data?.cart_url) {
        window.WCCP_TIMING?.flush?.(true);
        window.location.href = json.data.cart_url;
    } else {
        window.WCCP_TIMING?.flush?.(true);
        window.location.reload();
    }

}